import { render, staticRenderFns } from "./RideHailingPreparePricing.vue?vue&type=template&id=7242f0fa&"
import script from "./RideHailingPreparePricing.vue?vue&type=script&lang=js&"
export * from "./RideHailingPreparePricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports